<template>
  <div
    v-if="!removeFromDOM"
    class="jfpc"
    :class="themeClass"
    :publisher-component-id="id"
    :publisher-component-placement="componentPlacement"
    :instance-id="instanceId"
  >
    <div v-if="modalDisplay" class="ads-modal__container">
      <tw-card class="ads-modal">
        <div v-show="!loading" class="awlistings" aw-implement="1" aw-category="1"></div>
      </tw-card>

      <div
        v-show="!loading"
        @click="() => { emitCloseModal(); }"
        class="cursor-pointer items-center font-medium" style="position: relative; margin-top: 4dvh; z-index: 100000000; pointer-events: all; color: #bdbdbd !important; display: flex; font-size: 12px"
      >
        <span>Go To Listings</span>
        <icon-chevron-right size="22" />
      </div>

      <div @click="emitCloseModal" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; pointer-events: all; background: transparent"></div>
    </div>

    <div v-else v-show="!loading" class="awlistings" aw-implement="1" aw-category="1"></div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import PublisherBase from "@/mixins/Publisher/PublisherBase";
import TwCard from "@/components/Tailwind/TwCard.vue";
import IconChevronRight from "@/components/Icon/IconChevronRight.vue";

export default {
  name: "ExternalAdUnitAutoweb",
  components: { TwCard, IconChevronRight },
  mixins: [
    PublisherBase
  ],
  props: {
    ...PublisherBase.props,
    postalCode: {
      type: String,
      default: ""
    },
    modalDisplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: 29,
      loading: true,
      makeModelEventHandlersAttached: [],
      listingsLoaded: 0,
      awListings: []
    };
  },
  computed: {},
  mounted() {},
  methods: {
    componentInit() {
      return new Promise((resolve) => {
        window.onerror = function(message, source, lineno, colno, error) {
          vm.triggerNoContentLoaded({
            advertiser_account_id: 1016
          });
          return false; // Allows default browser error handling to proceed
        };

        this.patchAutowebListingsRequest();
        window.addEventListener("aw-listings-loaded", this.onAutowebListingsLoaded);

        let s = document.createElement("script");
        s.src = "//cdn.awadserver.com/widget/js/awloader.min.js";
        s.type = "text/javascript";
        // s.setAttribute("aw-placement-retail", "5250");
        // s.setAttribute("aw-placement", "5251");
        // s.setAttribute("aw-placement-top5", "5252");
        s.setAttribute("aw-placement", "5353");
        s.setAttribute("count", "2");
        s.setAttribute("aw-zipcode", this.postalCode);
        s.setAttribute("aw-make", this.urlParams.get("make") ? this.urlParams.get("make") : "");
        s.setAttribute("aw-model", this.urlParams.get("model") ? this.urlParams.get("model") : "");
        document.getElementsByTagName('head')[0].appendChild(s);

        let vm = this;
        const adsLoadedErrorInterval = setInterval(() => {
          let adsQuerySelector = ".fail-cont";
          if (vm.shadowDOM.querySelectorAll(adsQuerySelector).length === 0) return;

          clearInterval(adsLoadedErrorInterval);
          clearInterval(adsLoadedInterval);

          vm.triggerNoContentLoaded({
            advertiser_account_id: 1016
          });
        });

        const adsLoadedInterval = setInterval(() => {
          let adsQuerySelector = "#awImp1";
          if (vm.shadowDOM.querySelectorAll(adsQuerySelector).length === 0) return;

          clearInterval(adsLoadedInterval);
          clearInterval(adsLoadedErrorInterval);

          if (vm.shadowDOM.querySelectorAll(".lstnRow").length === 0) {
            vm.triggerNoContentLoaded({
              advertiser_account_id: 1016
            });
          } else {
            vm.$emit('ads-loaded');

            // Set scrollable height for modal display mode
            if (vm.modalDisplay) {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  let lstnRows = vm.shadowDOM.querySelectorAll(".lstnRow");
                  if (lstnRows.length > 0) {
                    setTimeout(() => {
                      let firstRowHeight = lstnRows[0].offsetHeight;
                      let awlistingsContainer = vm.shadowDOM.querySelector(".awlistings");
                      if (awlistingsContainer && firstRowHeight > 0) {
                        awlistingsContainer.style.height = firstRowHeight + "px";
                        awlistingsContainer.style.overflowY = "auto";
                      }
                    }, 5);
                  }
                });
              });
            }

            this.attachMakeModelEventHandlers(this.urlParams.get("make") ? this.urlParams.get("make") : "", this.urlParams.get("model") ? this.urlParams.get("model") : "");

            /*let initialMenuItem = vm.shadowDOM.querySelector("#menu-list .nombre.car-fas-menu__active");
            let initialMake = initialMenuItem.getAttribute("make");
            let initialModel = initialMenuItem.getAttribute("model");
            this.attachMakeModelEventHandlers(initialMake, initialModel);

            let menuItems = vm.shadowDOM.querySelectorAll("#menu-list .nombre");
            for (let i = 0; i < menuItems.length; i++) {
              let thisMenuItem = menuItems.item(i);
              thisMenuItem.addEventListener("click", () => {
                let activeMake = thisMenuItem.getAttribute("make");
                let activeModel = thisMenuItem.getAttribute("model");
                this.attachMakeModelEventHandlers(activeMake, activeModel);
              });
            }*/
          }
          this.loading = false;

        }, 20);

        resolve();
      });
    },
    attachMakeModelEventHandlers(make, model) {
      if (!this.makeModelEventHandlersAttached.includes(make + " " + model)) {
        let makeModel = make + " " + model;
        this.makeModelEventHandlersAttached.push(makeModel);

        this.jfpTrack("ContentView", {
          advertiser_account_id: 1016,
          publisher_channel_2: "jfkw_" + makeModel,
          // advertiser_channel_1: XXX,
          // advertiser_channel_2: XXX,
          // advertiser_channel_3: XXX
        });

        let vm = this;
        const listingsLoadedInterval = setInterval(() => {
          let adsQuerySelector = ".lstnRow a";
          if (vm.shadowDOM.querySelectorAll(adsQuerySelector).length <= this.listingsLoaded) return;

          clearInterval(listingsLoadedInterval);

          let rows = vm.shadowDOM.querySelectorAll(".lstnRow a");
          for (let i = 0; i < rows.length; i++) {
            let thisRow = rows.item(i);
            if (thisRow.getAttribute("attached") != 1) {
              ++this.listingsLoaded;

              thisRow.setAttribute("attached", 1);

              this.attachRankScore(thisRow);

              // Add click event listeners
              thisRow.addEventListener("click", () => {
                let row = thisRow.closest(".lstnRow");
                let rankScore = row && row.dataset.rankScore !== undefined ? parseFloat(row.dataset.rankScore) : NaN;

                vm.jfpTrack("ContentClick", {
                  advertiser_account_id: 1016,
                  event_value: isNaN(rankScore) ? 0.01 : rankScore
                });
                sessionStorage.setItem(window.location.hostname + "-adClicked", "1016");
              });
            }
          }
        });
      }
    },
    patchAutowebListingsRequest() {
      // The Autoweb loader fetches listings with a plain XMLHttpRequest and keeps the
      // response in closure scope, so patch open() once to re-broadcast the parsed JSON.
      if (window.__awListingsXhrPatched) return;
      window.__awListingsXhrPatched = true;

      const origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        if (typeof url === "string" && url.indexOf("search.awadserver.com/Ads/Listings") !== -1) {
          this.addEventListener("load", () => {
            try {
              const data = this.responseType === "json" ? this.response : JSON.parse(this.responseText);
              // The loader also hits this endpoint with DisplayCount:0 just for an impression id
              if (data && Array.isArray(data.Listings) && data.Listings.length > 0) {
                window.dispatchEvent(new CustomEvent("aw-listings-loaded", { detail: data }));
              }
            } catch (e) {
              // ignore unparseable responses
            }
          });
        }
        return origOpen.call(this, method, url, ...rest);
      };
    },
    onAutowebListingsLoaded(e) {
      this.awListings = e.detail.Listings;

      // Rows may already be in the DOM if the response arrived before this listener ran
      let rows = this.shadowDOM ? this.shadowDOM.querySelectorAll(".lstnRow a") : [];
      for (let i = 0; i < rows.length; i++) {
        this.attachRankScore(rows.item(i));
      }
    },
    attachRankScore(rowLink) {
      let row = rowLink.closest(".lstnRow");
      if (!row || row.dataset.rankScore !== undefined) return;

      let href = rowLink.getAttribute("href") || "";
      let match = this.awListings.find((listing) => {
        if (!listing.LandingUrl) return false;
        // href is the LandingUrl with a protocol prepended; match on the unique impressionstate token
        return href.indexOf(listing.LandingUrl.replace(/^(https?:)?\/\//, "")) !== -1;
      });

      if (match && match.RankScore !== undefined) {
        row.dataset.rankScore = match.RankScore;
      }
    },
    emitCloseModal: function () {
      this.$emit('close-ads-modal');
    },
  },
  beforeDestroy() {
    window.removeEventListener("aw-listings-loaded", this.onAutowebListingsLoaded);
  }
}
</script>

<style src="@/styles/index.css" />
<style scoped>
.ads-modal__container {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.55);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100dvh;
  padding: 1rem;
  padding-top: 32px;
}
.ads-modal {
  z-index: 1000000;
  width: 96%;
  max-width: 1024px;
  position: relative;
  margin: 0 1rem;
  overflow: visible;
  pointer-events: all;
  padding: 0 !important;
  border-radius: 14px;
}
</style>
<style>
.ads-modal .awlistings {
  border-radius: 7px;
}
.ads-modal .awHeader {
  position: absolute;
  bottom: 100%;
  color: #ddd;
  left: -8px;
  height: auto !important;
  padding-bottom: 6px !important;
}
.ads-modal #awImp1 .lstnCTA h1 {
  font-size: 14px !important;
}
.ads-modal .lstnRow a {
  padding: 12px;
  height: auto !important;
}
.ads-modal .lw-aw__container-powered-by {
  margin-top: 8px !important;
  padding-bottom: 8px !important;
}
.ads-modal .lstnTitle {
  font-size: 18px !important;
}
.ads-modal .lstnAct strong {
  font-size: 20px !important;
  line-height: 23px !important;
}
</style>